import { render, staticRenderFns } from "./AddressChange.vue?vue&type=template&id=ec1ce58c&scoped=true"
import script from "./AddressChange.vue?vue&type=script&lang=js"
export * from "./AddressChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1ce58c",
  null
  
)

export default component.exports